/**
 * event types for events emitted by toolbar
 */
export enum WlEventsToolbarEventTypeEnum {
  search,
  searching,
  clearKeyword,
  newEvent,
  deleteEvent, // data param should be a number representing the event id
  newRegistration, // data param should be a number representing the event id
  editRegistration, // data param should be: { EventId: this.event.EventId, RegistrationId: registration.Id }
  editAttendee, // data param should be: { EventId: this.event.EventId, RegistrationId: Number(attendee.RegistrationId), AttendeeId: attendee.AttendeeId }
  registrationSaved,
  requestKeyword,
  requestKeywordAnswer,
  registrationClosed,
}
